import { createApp } from 'vue'; // Adjusted for Vue 3
import App from './App.vue';
import router from './router'; // Ensure this path is correct

// Create the Vue application and use the router
createApp(App)
  .use(router)
  .mount('#app');